var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrownOutline = function SvgCrownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB31B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.134 12.654H4.866a.79.79 0 0 1-.687-.487l-2.76-7.72C1.027 3.34 1.487 3 2.433 3.68l2.6 1.86c.434.3.927.147 1.114-.34L7.32 2.073c.373-1 .993-1 1.367 0L9.86 5.2c.187.487.68.64 1.107.34l2.44-1.74c1.04-.747 1.54-.367 1.113.84l-2.693 7.54c-.1.254-.413.473-.694.473M4.334 14.667h7.333M6.334 9.333h3.333"
  })));
};
export default SvgCrownOutline;